import React from 'react';
import { MetricsElement } from "react-metrics";

import Link from '../../../shared/components/hyperlink';

import './chips.less';


const chip = (props) => {

  let {title="", header="", element='span'} = props;
  if(typeof title === 'object'){
    title = title['key'];
  }

  const titleDisplay = title.split("-").join(" ").toLowerCase();
  const eventId = header.replace(" ", "").toLowerCase() + ":clicked";

  return (
    <MetricsElement
      element={element}
      data-metrics-event-name="linkClick"
      data-metrics-event="e_linkClick"
      data-metrics-link-id={eventId}
      className='chip'
    >
      <Link to={'/tech-takes/article-filters/tags=' + title}>
	        {titleDisplay}
      </Link>
    </MetricsElement>
  );
}

export default chip;
